// src/screens/GenerateKeyScreen.js
import React, { useState } from "react"
import axios from "axios"
import { toast } from "react-toastify"
import "../styles.css"

const GenerateKeyScreen = () => {
  const [email, setEmail] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const handleGenerateKey = async (e) => {
    if (e) e.preventDefault()
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!email) {
      toast.error("Email is required")
      return
    }

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address")
      return
    }

    setIsLoading(true) // Set loading state to true

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/email/generate-key`,
        {
          email,
        }
      )
      toast.success(response.data)
      setEmail("")
    } catch (error) {
      toast.error(
        error.response?.data || "An error occurred while generating the key"
      )
    } finally {
      setIsLoading(false) // Reset loading state
    }
  }

  return (
    <div className="auth-page">
      <aside className="auth-brand">
        <div className="auth-rings" aria-hidden="true">
          <span className="ring ring-1" />
          <span className="ring ring-2" />
          <span className="ring ring-3" />
          <span className="auth-coin" />
        </div>

        <div className="auth-brand-inner">
          <img src="/logo.svg" alt="Project 31 Logo" className="auth-brand-logo" />
          <h1 className="auth-brand-title">
            Own a slice of <span>Bitcoin</span>.
          </h1>
          <p className="auth-brand-text">
            Project 31 is a community stacking sats together — transparent
            reporting, every month, on autopilot.
          </p>
          <ul className="auth-features">
            <li>
              <span className="auth-feature-dot" /> Track your holdings in real
              time
            </li>
            <li>
              <span className="auth-feature-dot" /> Transparent monthly community
              reports
            </li>
            <li>
              <span className="auth-feature-dot" /> Secure, passwordless access
            </li>
          </ul>
        </div>
      </aside>

      <main className="auth-panel">
        <div className="login-card">
          <img
            src="/logo.svg"
            alt="Project 31 Logo"
            className="login-card-logo"
          />

          <h1 className="login-heading">View Bitcoin Balance</h1>
          <p className="login-sub">
            Enter your email and we'll send you a secure access link to view
            your holdings and performance.
          </p>

          <form onSubmit={handleGenerateKey}>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading} // Disable input while loading
            />
            <button type="submit" className="primary-cta" disabled={isLoading}>
              {isLoading ? (
                <span className="spinner" aria-hidden="true"></span> // Spinner element
              ) : (
                "Send Access Token"
              )}
            </button>
          </form>

          <p className="login-hint">Secure, passwordless sign-in</p>
        </div>
      </main>
    </div>
  )
}

export default GenerateKeyScreen
